import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton, Popover, Tooltip } from "@mui/material";
import { memo, useCallback, useState, type MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { ReportDescriptionContent } from "./ReportDescriptionContent";
import { REPORTS_TRANSLATION_PATH } from "./shared";

interface IReportDescriptionButtonProps {
  description: string;
}

const ReportDescriptionButtonComponent: React.FC<
  IReportDescriptionButtonProps
> = ({ description }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const openHandler = useCallback((event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const closeHandler = useCallback(() => setAnchorEl(null), []);

  return (
    <>
      <Tooltip
        title={
          anchorEl ? "" : <ReportDescriptionContent description={description} />
        }
      >
        <IconButton
          size="small"
          aria-label={
            t(REPORTS_TRANSLATION_PATH + "description") || "Description"
          }
          onClick={openHandler}
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={closeHandler}
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box sx={{ p: 2, maxWidth: 360 }}>
          <ReportDescriptionContent description={description} />
        </Box>
      </Popover>
    </>
  );
};

export const ReportDescriptionButton = memo(ReportDescriptionButtonComponent);
